/* eslint no-prototype-builtins: "off" */

'use strict';

const jQuery = require('jquery');

const RequestHandler = require('./../../../core/requestHandler');

const baseType = 'bundle';

let bundles = [];

const normalizeUrl = (url) => {
    return (url.substring(0, 1) === '/') ? url.substring(1) : url;
};

module.exports.bundles = bundles;

module.exports.findAll = function() {
    let dfd = jQuery.Deferred();

    if (bundles.length) {
        dfd.resolve(bundles);
    } else {
        RequestHandler.read(baseType).done((data) => {
            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    if (data[key]['bundle_admin_entrypoint']) {
                        bundles.push(data[key]);
                    }
                }
            }

            dfd.resolve(bundles);
        });
    }

    return dfd.promise();
};

module.exports.getByUrl = function(url, data) {
    let result;

    url = normalizeUrl(url);

    RequestHandler.setBaseUrl('');

    result = RequestHandler.read(url, data);

    RequestHandler.setBaseUrl('/rest/2');

    return result;
};

const getFunc = (method) => {
    let converter = {
        'POST': 'create',
        'GET': 'read',
        'PUT': 'update',
        'PATCH': 'patch',
        'DELETE': 'del',
    };

    return converter[method];
};

module.exports.request = function(url, data, method = 'GET') {
    let result;

    url = normalizeUrl(url);

    RequestHandler.setBaseUrl('');

    result = RequestHandler[getFunc(method)](url, data);

    RequestHandler.setBaseUrl('/rest/2');

    return result;
};
